// eslint-disable-next-line import/prefer-default-export
export function descStringArraySorter(a, b) {
  if (a < b) return 1;
  if (a > b) return -1;
  return 0;
}
